module.exports = __webpack_public_path__ + "media/images/emblems/Berken-coat_of_arms-555df3d2e922f989e0a4f0b84364f5d1.svg";